import { chipClasses } from '@mui/material'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const ObjectDisplayStyles: moduleStyleType = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    identifier: {
        marginLeft: '3px',
        fontSize: '12px',
        height: 'auto',
        [`.${chipClasses.label}`]: {
            paddingLeft: 1,
            paddingRight: 1,
        },
        fontWeight: 400,
    },
    separator: {
        marginRight: '2px',
        marginLeft: '2px',
    },
    metadata: {
        fontSize: '12px',
        color: 'text.secondary',
    },
    drawerTitleContainer: {
        marginBottom: 1,
    },
    avatarContainer: {
        marginRight: 2,
    },
    metadataBox: {
        display: 'flex',
        alignItems: 'center',
    },
    metadataTruncatedSeparator: {
        marginLeft: '-4px',
    },
    metadataTruncatedContainer: {
        maxWidth: '12ch',
    },
}
